import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { format, startOfDay, subDays } from "date-fns";
import HeaderFilter from "../../../../components/header/filter";
import DatePickerInputV1 from "../../../../components/inputs/date-time/v1";
import { BtnSearch } from "../../../../components/button/button-search";
import { schemaFiltro } from "../../filtros";

const DIAS_SEFAZ = 99;

function schemaSefaz() {
	const minimo = startOfDay(subDays(new Date(), DIAS_SEFAZ));

	return schemaFiltro.refine((f) => f.dtIni >= minimo, {
		message: `A SEFAZ-SP só consulta os últimos 100 dias: data inicial a partir de ${format(minimo, "dd/MM/yyyy")}`,
		path: ["dtIni"],
	});
}

export default function FiltroSefaz({ titulo, filtros, onFiltrar }) {
	const {
		control,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schemaSefaz()),
		defaultValues: filtros,
	});

	return (
		<form onSubmit={handleSubmit(onFiltrar)} autoComplete="off">
			<HeaderFilter title={titulo} />

			<div className="flex flex-col md:flex-row gap-4 mt-2 border-bottom pb-2">
				<div className="w-full md:w-1/2">
					<DatePickerInputV1 label="Data inicial" id="dtIni" control={control} errors={errors} />
				</div>
				<div className="w-full md:w-1/2">
					<DatePickerInputV1 label="Data final" id="dtFim" control={control} errors={errors} />
				</div>
			</div>

			<footer>
				<div></div>
				<BtnSearch isSubmitting={isSubmitting} />
			</footer>
		</form>
	);
}
